import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import RolePageAccessLayer from '../components/RolePageAccessLayer'

const RolePageAccessPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title='Role Page Access Management' />
      <RolePageAccessLayer />
    </MasterLayout>
  )
}

export default RolePageAccessPage

